import Vue from 'vue'
import Vuex from 'vuex'
import geoLocation from './modules/geo-location';
import courseTerms from './modules/course-terms';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
    modules: {
        geoLocation:geoLocation,
        courseTerms:courseTerms,
    },
    strict: debug
});